































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { IEmailConfirmation } from '@/features/account/api/auth.interfaces';

@Component({
  name: 'emailConfirmation',
})
export default class EmailConfirmation extends Vue {
  // Locals
  confirm: IEmailConfirmation = {} as IEmailConfirmation;
  loading: boolean = false;
  failed: boolean = false;

  // Lifecycle Functions
  mounted(): void {
    this.confirm.userId = this.$route.query.userid;
    this.confirm.code = this.$route.query.code;
    var self = this;

    if (this.confirm.userId && this.confirm.code) {
      this.loading = true;

      this.$store
        .dispatch('auth/confirm', this.confirm)
        .then((response: IApi<string>) => {
          self.loading = false;
        })
        .catch((error: any) => {
          self.failed = true;
          self.loading = false;
        });
    }
  }
}
